import React from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-cycle
import { NotFound } from "..";

function ShowOnlyInDevelopment({ children, isRoute }) {
  const isDevEnv = process.env.REACT_APP_STAGE === "dev";

  if (isRoute) {
    return isDevEnv ? children : <NotFound />;
  }

  return isDevEnv ? children : null;
}

ShowOnlyInDevelopment.propTypes = {
  isRoute: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
ShowOnlyInDevelopment.defaultProps = {
  isRoute: false,
};

export default ShowOnlyInDevelopment;
